<template>
    <div name="ddown">
<!--         <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name !== undefined">
          {{ selectedOption.name }}
          <span class="caret"></span>
        </li>

        <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name === undefined">
          {{placeholderText}}
          <span class="caret"></span>
        </li>

        <ul  v-if="showMenu" >
            <li v-for="option in options">
                <a  @click="updateOption(option)">
                    {{ option.name }}
                </a>
            </li>
        </ul>
 -->


 <div class="select" v-bind:style="{ width: dropWidth + 'em' }" >
 <select name="slct" id="slct"  v-on:change="updateOption" >
    <option v-for="option in options" :value="option.id" :selected="isSelected(option.id)" > {{ option.name }}</option>
  </select>
</div>


    </div>
</template>



<script>
    export default {
        name: 'ddown',
       computed: {
          dropWidth () {
            return this.width == undefined ? 15 : this.width
          }
        },
        data() {
            return {
                selectedOption: {
                  name: '',
                },
                placeholderText: 'Please select an item',
            }
        },
        props: {
            options: {
                type: [Array, Object]
            },
            selected: {},
            placeholder: [String],
            width: Number
        },

        mounted() {
            this.selectedOption = this.selected;
            if (this.placeholder)
            {
                this.placeholderText = this.placeholder;
            }
        },

        methods: {
            updateOption(e) {
              var valObj = this.options.filter(function(elem){
                return elem.id == e.target.value
              });

              if(valObj.length > 0) {
                this.selectedOption = valObj[0]
                this.$emit('updateOption', this.selectedOption)
              }
            },
            isSelected (val) {
              return this.selected.id == val ? 'selected' : ''
            },

            toggleMenu() {
              this.showMenu = !this.showMenu;
            }
        }
    }
</script>

<style>

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0 !important;


  flex: 1;
  padding: 0 1.5em;
  color: #000;
  cursor: pointer;
}

select::-ms-expand {
  display: none;
}

.select {
  position: relative;
  display: flex;
  width: 20em;
  height: 3em;
  line-height: 3;
  overflow: hidden;
  border-radius: .25em;

}
.select::after {
  content: '\25BC';
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 1em;
  background: #34495e;
  cursor: pointer;
  pointer-events: none;
  -webkit-transition: .25s all ease;
  -o-transition: .25s all ease;
  transition: .25s all ease;
}


.select:hover::after {
  color: #f39c12;
}


</style>
